import React, { useEffect, useState } from "react";
import "./PaymentSuccessfulStyle.scss";
import greenTickIcon from "../../assets/images/greentickIcon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getPolicyDetails } from "../../Redux/MedicalRedux";
import {
  getPolicyDocuments,
  getPolicyDocumentsMedical,
} from "../../Redux/IndividualMedicalRedux";
import { use } from "react";
import {
  updateQuotesMedical,
  uploadPolicyDocumentMedical,
} from "../../Redux/LogsRedux/Medical/MedicalQuotesRedux";
import { documentUpload } from "../../Redux/loadingReducer";
import CustomModal from "../Common/CustomModal/CustomModal";
import { useTranslation } from "react-i18next";

function PaymentSuccessful() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSuccess, setIsSuccess] = useState(false);
  const [policyNumber, setPolicyNumber] = useState("");
  const [coverPlan, setCoverPlan] = useState("");
  const [encoded, setEncoded] = useState("");
  const [loading, setLoading] = useState(false);
  const [policyBlob, setPolicyBlob] = useState(null);
  const [pdfList, setPdfList] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [fileName, setFileName] = useState();

  const { t,i18n } = useTranslation();

  const handleSubmit = () => {
    localStorage.removeItem("MEDICAL_LEAD_ID");
    localStorage.removeItem("MEDICAL_QUOTE_ID");
    navigate("/");
  };

  const handlePreview = (pdf) => {
    if (pdf?.url) {
      setFileName(pdf.title);
    setIsSummaryOpen(true);
      setSelectedPdf(pdf.url);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const policyNum = params.get("policyNumber");
    const encodedPolicyNumber = encodeURIComponent(policyNum);
    setEncoded(encodedPolicyNumber);

    if (policyNum) {
      setPolicyNumber(decodeURIComponent(policyNum));
      dispatch(getPolicyDetails(encodedPolicyNumber)).then((result) => {
        if (result.success) {
          setCoverPlan(result?.data?.plan);
        }
      });
    }
  }, []);

  
  const createBlobUrlFromBase64 = (base64String, documentName) => {
    try {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      return url;
    } catch (error) {
      console.error(`Error converting ${documentName} to blob URL:`, error);
      return null;
    }
  };

  const documentTitles = {
    policy_document: "Policy Document",
    policy_schedule: "Policy Schedule",
    tax_invoice: "Tax Invoice",
    table_of_benefits: "Table of Benefits",
    receipt_voucher: "Receipt Voucher",
  };

  useEffect(() => {
    if (!policyNumber) return;
    dispatch(documentUpload(false));
    dispatch(
      updateQuotesMedical({
        paymentStatus: "PAYMENT_SUCCEEDED",
        quoteId: localStorage.getItem("MEDICAL_QUOTE_ID"),
        policyNo: policyNumber,
        quoteStatus:"POLICY_ISSUED"
      }),
    );

    setLoading(true);
    dispatch(getPolicyDocumentsMedical(encodeURIComponent(policyNumber))).then(
      (res) => {
        if (res?.success && res?.data) {
          const documents = res.data;
          const newPdfList = [];
          Object.entries(documents).forEach(([key, base64Data]) => {
            if (base64Data) {
              const url = createBlobUrlFromBase64(base64Data, key);
              if (url) {
                newPdfList.push({
                  url: url,
                  title: documentTitles[key] || key.replace(/_/g, " "),
                  documentName: key,
                  policyNumber: policyNumber,
                });
              }
            }
          });

          setPdfList(newPdfList);
          setLoading(false);

          const policyBase64 = documents.policy_document;
          if (policyBase64) {
            const byteCharacters = atob(policyBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            setPolicyBlob(blob);

            const formData = new FormData();
            formData.append(
              "policyDocumentMedical",
              blob,
              `Policy_${policyNumber}.pdf`,
            );
            dispatch(
              uploadPolicyDocumentMedical(
                formData,
                localStorage.getItem("MEDICAL_QUOTE_ID"),
              ),
            );
          }
        } else {
          setLoading(false);
        }
      },
    );

    return () => {
      pdfList.forEach((pdf) => {
        if (pdf.url) {
          URL.revokeObjectURL(pdf.url);
        }
      });
    };
  }, [isSuccess, policyNumber, dispatch]);

  return (
    <>
      {/* <TopNavBar /> */}
      <div className="container-fluid bg-white py-4">
        <div className="d-flex justify-content-center">
          <div className="col-12 col-md-10 col-lg-5">
            <div className="text-center">
              <img
                src={greenTickIcon}
                alt="greentickicon"
                className="img-fluid mx-auto success-animate"
                style={{ width: "80px" }}
              />

              <h5 className="mt-3 mb-1 payment-success-label">
                {t("Your premium payment is successful.")}
              </h5>
              <p className="fw-bold mb-3 payment-success-label">{t("Thank you")}!</p>
            </div>
            <div
              className="card shadow-sm rounded-4 p-4"
              style={{ width: "100%", maxWidth: "520px", margin: "0 auto" }}
            >
              <h5 className="fw-semibold mb-4 text-center">{t("Policy Details")}</h5>

              <div className="row mb-2">
                <div className="col-5 text-muted">{t("Policy No")}</div>
                <div className="col-7 text-end fw-medium">{policyNumber}</div>
              </div>
            </div>

            <div className="m-4 d-flex justify-content-center">
              {loading ? (
                  <div className="d-flex align-items-center gap-2">
                    <div className="loader-sm"></div>

                    <p className="fw-semibold mb-0">
                      {t("Please wait your document is loading...")}
                    </p>
                  </div>
              ) : pdfList.length > 0 ? (
                <div style={{ width: "100%", maxWidth: "520px" }}>
                  <table className="table table-borderless mb-0">
                    <tbody>
                      {pdfList.map((pdf, index) => (
                        <tr key={index}>
                          <td className="fw-semibold">{t(pdf.title)}</td>
                          <td className={`d-flex gap-2 ${i18n.language === "ar" ? "justify-content-center" : "justify-content-end"}`}>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => handlePreview(pdf)}
                              disabled={!pdf.url}
                            >
                              {t("Preview")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                if (!pdf.url) return;
                                const link = document.createElement("a");
                                link.href = pdf.url;
                                link.download = `${pdf.documentName}_${pdf.policyNumber}.pdf`;
                                link.click();
                              }}
                              disabled={!pdf.url}
                            >
                              {t("Download")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">{t("No documents available")}</p>
              )}
            </div>

            <div className="d-flex justify-content-center align-item-center">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary fw-bold mb-3 rounded-5 "
              >
                {t("Go back home")}
              </button>
            </div>
            <p className="acknowledge-para small text-muted ">
              {t("Your policy has been sent to you via WhatsApp and email according")}
              {t("to your communication preferences.")} <br />
              {t("Additionally, an SMS link has been provided for you to download")}
              {t("your policy document.")}
            </p>
          </div>
        </div>
          <CustomModal
        isOpen={isSummaryOpen}
        onClose={() => {
          setIsSummaryOpen(false);
          setSelectedPdf(null);
        }}
        title={fileName}
        download={true}
        pdfUrl={selectedPdf}
      >
        <div
          className="modal-body"
          style={{ overflow: "hidden", padding: 0, height: "70vh" }}
        >
          {selectedPdf && (
            <iframe
              title="View Document"
              src={`${selectedPdf}#page=1&toolbar=0`}
              width="100%"
              height="95%"
              style={{ border: "none" }}
            />
          )}
        </div>
      </CustomModal>
      </div>
    </>
  );
}

export default PaymentSuccessful;
